/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ProofFileApprovalItem model module.
 * @module model/ProofFileApprovalItem
 * @version V1
 */
class ProofFileApprovalItem {
    /**
     * Constructs a new <code>ProofFileApprovalItem</code>.
     * @alias module:model/ProofFileApprovalItem
     */
    constructor() { 
        
        ProofFileApprovalItem.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProofFileApprovalItem</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProofFileApprovalItem} obj Optional instance to populate.
     * @return {module:model/ProofFileApprovalItem} The populated <code>ProofFileApprovalItem</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProofFileApprovalItem();

            if (data.hasOwnProperty('approved')) {
                obj['approved'] = ApiClient.convertToType(data['approved'], 'Boolean');
            }
            if (data.hasOwnProperty('approvedWithChanges')) {
                obj['approvedWithChanges'] = ApiClient.convertToType(data['approvedWithChanges'], 'Boolean');
            }
            if (data.hasOwnProperty('fileId')) {
                obj['fileId'] = ApiClient.convertToType(data['fileId'], 'Number');
            }
            if (data.hasOwnProperty('fileName')) {
                obj['fileName'] = ApiClient.convertToType(data['fileName'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ProofFileApprovalItem</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ProofFileApprovalItem</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['fileName'] && !(typeof data['fileName'] === 'string' || data['fileName'] instanceof String)) {
            throw new Error("Expected the field `fileName` to be a primitive type in the JSON string but got " + data['fileName']);
        }

        return true;
    }


}



/**
 * @member {Boolean} approved
 */
ProofFileApprovalItem.prototype['approved'] = undefined;

/**
 * @member {Boolean} approvedWithChanges
 */
ProofFileApprovalItem.prototype['approvedWithChanges'] = undefined;

/**
 * @member {Number} fileId
 */
ProofFileApprovalItem.prototype['fileId'] = undefined;

/**
 * @member {String} fileName
 */
ProofFileApprovalItem.prototype['fileName'] = undefined;






export default ProofFileApprovalItem;

